import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FetchingStatus } from '../../model/fetchingStatus';
import { RootState } from '../store';

export interface LiteMarket {
    name: string;
    celer: string;
    logo: string;
    toName: string;
    toCeler: string;
    toLogo: string;
}

export interface LiteMarketState {
    status: FetchingStatus;
    liteMarkets: LiteMarket[];
}

export const defaultMarkets: LiteMarket[] = [
    { name: 'BTC', celer: 'BTC', logo: 'btc', toName: 'USD', toCeler: 'USD', toLogo: 'usd' },
    { name: 'ETH', celer: 'ETH', logo: 'eth', toName: 'USD', toCeler: 'USD', toLogo: 'usd' },
    { name: 'USDT', celer: 'UST', logo: 'usdt', toName: 'USD', toCeler: 'USD', toLogo: 'usd' },
    { name: 'BNB', celer: 'BNB', logo: 'bnb', toName: 'USD', toCeler: 'USD', toLogo: 'usd' },
    { name: 'USDC', celer: 'USC', logo: 'usdc', toName: 'USD', toCeler: 'USD', toLogo: 'usd' },
    { name: 'XRP', celer: 'XRP', logo: 'xrp', toName: 'USD', toCeler: 'USD', toLogo: 'usd' }
];

const initialState: LiteMarketState = {
    status: 'idle',
    liteMarkets: defaultMarkets
};

export const liteMarketSlice = createSlice({
    name: 'liteMarket',
    initialState,
    reducers: {
        setLiteMarkets: (state, action: PayloadAction<LiteMarket[]>) => {
            state.liteMarkets = action.payload;
        }
    }
});

export const { setLiteMarkets } = liteMarketSlice.actions;
export const selectLiteMarkets = (state: RootState) => state.liteMarket.liteMarkets;

export default liteMarketSlice.reducer;
